export const Breakpoints = {
  "minMobile": 420,
  "maxTablet": 839,
  "minTablet": 840,
  "maxDesktop": 1079,
  "minDesktop": 1080,
  "minDesktopLarge": 1800
};